import { render, staticRenderFns } from "./upHouse.vue?vue&type=template&id=289149b0&scoped=true&"
import script from "./upHouse.vue?vue&type=script&lang=js&"
export * from "./upHouse.vue?vue&type=script&lang=js&"
import style0 from "./upHouse.vue?vue&type=style&index=0&id=289149b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "289149b0",
  null
  
)

export default component.exports